<template>
    <div class="brt-button" :type="type">
        <i v-if="icon" :class="'iconfont ' + icon "></i>
        <span>
            <slot></slot>
        </span>
    </div>
</template>

<script>
    export default {

        name: "Button",

        data(){
            return {}
        },

        props:{
            type:String,

            icon: {
                defalut: '',
                type: String
            }
        },


        computed:{
            getType(){
                // console.log(this);
                return this.type;
            }
        },

        watch:{
          getType(n,o){
              // console.log(n,o);
          }
        },

        mounted:function () {}
    }
</script>


<style lang="less">

    @import "../../styles/comm.less";

    .brt-button {
        display: flex;
        justify-content: center;
        align-items: center;
        /*display: inline-block;*/
        height: @buttonDefaultHeight;
        /*line-height: @buttonDefaultHeight;*/
        border-radius: @buttonDefaultHeight;
        background-color: @buttonColorA1;
        color: @buttonReverseColor;
        font-size: @buttonDefaultSize;
        padding: 0 @spacingNumber;
        text-align: center;



        &:active{background-color: @buttonActiveColor}

        &[type='border'] {
            background-color: transparent;
            border: 1px solid @buttonColorA1;
            color: @buttonColorA1 ;

            &:active{
                background-color: transparent;
                border-color: @buttonActiveColor;
                color: @buttonActiveColor
            }
        }


        &[type='dark']{

            background-color:@buttonColorA2;
            border-color: @buttonColorA2;
        }

        &[type='block']{

            background-color:fade(#333333,90%);
            border-color: fade(#333333,90%);

            &:active{opacity: .8}
        }

        &[size='small'] {
            height: @buttonSmallHeight;
            line-height: @buttonSmallHeight;
            border-radius: @buttonSmallHeight;
            font-size: @buttonSmallSize;
        }

        >i{margin-right: @standartSpaceA1;vertical-align: middle}

        >span{display: inline-block;vertical-align: middle}
    }

</style>
